module.exports = __webpack_public_path__ + "static/img/002-collaboration.fefa42e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/002-collaboration.png
// module id = 351
// module chunks = 2